import React from 'react';
import { Helmet } from 'react-helmet';

function RefundPolicy() {
  return (
    <div className="policy-container">
      <Helmet>
        <title>Refund Policy - Fitness Health Blog</title>
        <meta name="description" content="Refund and Return Policy for Fitness Health Blog products." />
      </Helmet>

      <div className="policy-content">
        <h1>Refund Policy</h1>
        <p>Last Updated: January 15, 2025</p>

        <h2>Our Commitment</h2>
        <p>
          At Fitness Health Blog, we are committed to your satisfaction. We want you to be completely happy with your 
          purchase. If for any reason you are not satisfied with your order, we offer a comprehensive refund policy to 
          ensure your peace of mind.
        </p>

        <h2>30-Day Return Policy</h2>
        <p>
          We offer a 30-day return policy on most items. If 30 days have passed since your purchase, unfortunately we 
          cannot offer you a refund or exchange. To be eligible for a return, your item must be:
        </p>
        <ul>
          <li>Unused and in the same condition that you received it</li>
          <li>In the original packaging</li>
          <li>Accompanied by the receipt or proof of purchase</li>
        </ul>

        <h2>Non-Returnable Items</h2>
        <p>
          Several types of goods are exempt from being returned for health and safety reasons:
        </p>
        <ul>
          <li>Opened supplements, vitamins, or nutritional products</li>
          <li>Personal care items that have been opened or used</li>
          <li>Items marked as final sale or clearance</li>
          <li>Gift cards</li>
        </ul>

        <h2>How to Request a Return</h2>
        <p>
          To initiate a return, please contact our customer service team:
        </p>
        <ul>
          <li>Email us at info@topfitnessproducts.com with your order number and reason for return</li>
          <li>Call us at +448648285526 during business hours</li>
          <li>We will provide you with a return authorization and instructions</li>
        </ul>

        <h2>Refund Process</h2>
        <p>
          Once we receive your returned item, we will inspect it and notify you of the approval or rejection of your 
          refund. If approved:
        </p>
        <ul>
          <li>Your refund will be processed within 5-7 business days</li>
          <li>A credit will automatically be applied to your original method of payment</li>
          <li>You will receive an email confirmation when the refund has been processed</li>
        </ul>

        <h2>Shipping Costs</h2>
        <p>
          You will be responsible for paying your own shipping costs for returning your item. Shipping costs are 
          non-refundable. If you receive a refund, the cost of return shipping will be deducted from your refund unless 
          the return is due to our error.
        </p>

        <h2>Exchanges</h2>
        <p>
          We only replace items if they are defective or damaged. If you need to exchange an item for the same product, 
          please contact us at info@topfitnessproducts.com and we will arrange the exchange at no additional cost to you.
        </p>

        <h2>Damaged or Defective Items</h2>
        <p>
          If you receive a damaged or defective item:
        </p>
        <ul>
          <li>Contact us immediately at info@topfitnessproducts.com</li>
          <li>Include photos of the damaged item and packaging</li>
          <li>We will arrange for a replacement to be sent at no cost to you</li>
          <li>We will provide a prepaid return label for the damaged item</li>
        </ul>

        <h2>Late or Missing Refunds</h2>
        <p>
          If you have not received a refund yet, first check your bank account again. Then contact your credit card 
          company, it may take some time before your refund is officially posted. If you have done all of this and you 
          still have not received your refund, please contact us at info@topfitnessproducts.com.
        </p>

        <h2>Contact Us</h2>
        <p>
          If you have any questions about our refund policy, please contact us:
        </p>
        <p>
          Email: info@topfitnessproducts.com<br />
          Phone: +448648285526<br />
          Address: Studio 52 Kennedy Grove South Wendy, NW2 2SH, United Kingdom<br />
          Company Registration: 27135609
        </p>
      </div>
    </div>
  );
}

export default RefundPolicy;